import { useIntl } from '@capsicum/common';
import { Text } from '@capsicum/common-web';
import { useWCPledgeLeaderboard } from '@capsicum/features/world-championship-pledge/shared';
import React from 'react';
import styled from 'styled-components';

import { WCPledgeLeaderboardCard } from '../../ui/leaderboardTab';

import { TabContentContainer } from './WCPledgeTabs.styled';

export const WCPledgeLeaderboardTab = () => {
	const { $t } = useIntl();
	const { isLoading, leaderboardMaxTeams, leaderboardTeams } = useWCPledgeLeaderboard();

	return (
		<S.StyledTabContentContainer>
			<S.Header>
				<S.Title variant="title5">{$t('worldChampionshipPledge.leaderboardTab.title')}</S.Title>
				<S.Disclaimer variant="text3">{$t('worldChampionshipPledge.leaderboardTab.disclaimer')}</S.Disclaimer>
			</S.Header>
			<S.ListContainer>
				{isLoading ? (
					<>
						{Array.from({ length: leaderboardMaxTeams }).map((_, index) => (
							<WCPledgeLeaderboardCard isLoading={isLoading} key={`skeleton-${index}`} />
						))}
					</>
				) : (
					leaderboardTeams.map((item, index) => (
						<WCPledgeLeaderboardCard
							isLoading={isLoading}
							item={item}
							key={item.team.id}
							rank={index + 1}
						/>
					))
				)}
			</S.ListContainer>
		</S.StyledTabContentContainer>
	);
};
namespace S {
	export const StyledTabContentContainer = styled(TabContentContainer)`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.large};
	`;

	export const Header = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const Title = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Disclaimer = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.subtle};
	`;

	export const ListContainer = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
